export const PATHS = {
  ROOT: '/',
  LOGIN: '/login',
  LOGOUT: '/logout',
  REGISTRATION: '/registration',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  CHECK_YOUR_EMAIL: '/check-your-email',
  VERIFY_EMAIL: '/verify/:token',
  EXPIRED_LINK: '/expired-link',
  ACCESS_DENIED: '/access-denied',
  NO_ORGANIZATION: '/no-organization',
  OIDC_CALLBACK: '/auth/callback',
  DASHBOARD: '/dashboard',
  AI_SYSTEMS: '/ai-systems',
  AI_SYSTEM_DETAIL: '/ai-systems/:id',
  LL144_ASSESSMENT: '/ai-systems/:id/ll144-assessment',
  QUESTIONNAIRE: '/questionnaire',
  USER_MANAGEMENT: '/user-management',
  USER_PROFILE: '/user-management/:userId',
  AUDIT_LOG: '/audit-log',
  SETTINGS: '/settings',
  SETTINGS_ACCOUNT: '/settings/account',
  SETTINGS_GENERAL: '/settings/general',
  SUPPORT: '/support',
  TERMSANDPRIVACY: '/terms-and-privacy'
} as const;
